module.exports = __webpack_public_path__ + "static/media/faq.8e66a1b6.svg";